// extracted by mini-css-extract-plugin
module.exports = {"limitWidth":"_2-iQTtiSdExrzFDfZgtDBu"};